/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Full_Desc4Inputs */

const en_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontend, backend, database, and auth designed as one system, not a frontend bolted onto a toy API.`)
};

const ar_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة أمامية وخلفية وقاعدة بيانات ومصادقة مصممة كنظام واحد، لا واجهة أمامية ملحقة بواجهة بدائية.`)
};

const bn_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রন্টএন্ড, ব্যাকএন্ড, ডেটাবেস ও অথ একটি সিস্টেম হিসেবে ডিজাইন, টয় API-তে লাগানো ফ্রন্টএন্ড নয়।`)
};

const de_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontend, Backend, Datenbank und Authentifizierung als ein System konzipiert, nicht als Frontend, das an eine Spielzeug-API geschraubt ist.`)
};

const es_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontend, backend, base de datos y autenticación diseñados como un solo sistema, no como un frontend integrado en una API de juguete.`)
};

const fr_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontend, backend, base de données et authentification conçus comme un seul système, et non comme un frontend boulonné sur une API jouet.`)
};

const pt_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Front-end, back-end, banco de dados e autenticação projetados como um sistema, não um front-end colado numa API de brinquedo.`)
};

const zh_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前端、后端、数据库和身份验证设计为一个系统，而不是固定在玩具 API 上的前端。`)
};

const tr_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön uç, arka uç, veritabanı ve kimlik doğrulama tek sistem olarak tasarlanır, oyuncak bir API'ye iliştirilmiş ön uç değil.`)
};

const ru_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интерфейс, бэкенд, база и аутентификация как одна система, а не фронтенд, прикрученный к игрушечному API.`)
};

const pl_svc_full_stack_web_apps_full_desc4 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontend, backend, baza danych i uwierzytelnianie zaprojektowane jako jeden system, a nie frontend przykręcony do zabawkowego API.`)
};

/**
* | output |
* | --- |
* | "Frontend, backend, database, and auth designed as one system, not a frontend bolted onto a toy API." |
*
* @param {Svc_Full_Stack_Web_Apps_Full_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_full_desc4 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Full_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Full_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_full_desc4(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_full_desc4(inputs)
	return en_svc_full_stack_web_apps_full_desc4(inputs)
});
export { svc_full_stack_web_apps_full_desc4 as "svc_full-stack-web-apps_FULL_desc" }